/* unplugin-vue-components disabled */import script from "./ApprovalDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalDialog.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalDialog.vue?vue&type=style&index=0&id=3e28d802&lang=scss"

const __exports__ = script;

export default __exports__